
define('ldsh!modules/form_editor/templates/editor_custom_terms', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-form-group js-label-group">\n  <label class="control-label">\n    <span data-i18n="formEditor.termsText">Texto del enlace </span> <span class="ed-icon ed-icon-help js-help"></span>\n  </label>\n  <div class="ed-form-group ed-form-group-file btn--secondary js-browse mb24 e100">\n    <label for="">\n      <span data-i18n="formEditor.termsLabel">Cargar fichero HTML</span>\n      <i class="ed-icon ri-upload-2-line" aria-hidden="true"></i>\n    </label>\n  </div>\n  <div role="tooltip" class="tooltip bottom js-tooltip">\n    <div class="tooltip-arrow"></div>\n    <div class="tooltip-inner" data-i18n="formEditor.termsHelp"></div>\n  </div>\n  <textarea class="js-text ed-form-control ed-form-item-full" rows="8" placeholder="Acepto los [Terminos y Condiciones](http://midominio.com/terminos) del servicio">' +
((__t = ( termsText )) == null ? '' : __t) +
'</textarea>\n</div>\n';

}
return __p
};});

